import { render, staticRenderFns } from "./CommunityCenterCard.vue?vue&type=template&id=13104c7c&scoped=true&"
import script from "./CommunityCenterCard.vue?vue&type=script&lang=js&"
export * from "./CommunityCenterCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13104c7c",
  null
  
)

export default component.exports